export default __webpack_public_path__ + "static/media/p4.f7c5663f.jpg";